export default "__VITE_ASSET__0b283544__"